import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faCircleXmark, faPencil, faEye } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/layout/Pagination'
import { toast } from 'react-toastify';

function Orders() {
  const API_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem('authToken');
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [errorMessage, setErrorMesage] = useState('')
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [selectedDeliveryStatus, setSelectedDeliveryStatus] = useState(null);
  const [searchedOrder, setSearchedOrder] = useState('');

  const deliveryStatus = [
    { label: 'Примена нарачка', value: 0 },
    { label: 'Доставено до карго', value: 1 },
    { label: 'Доставено до корисник', value: 2 },
    { label: 'Завршена нарачка', value: 3 },
    { label: 'Откажана', value: 4 },
  ];

  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders(searchedOrder, sortBy, pageSize, currentPage)
  }, [location.search])

  const fetchOrders = async (searchedOrder, sortBy, pageSize, currentPage) => {
    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/Order/orders?orderNumber=${searchedOrder}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        }
      })

      if (response.status === 401) {
        navigate('/');
      }

      const result = await response.json()

      if (result?.data?.orders) {
        const newQueryParams = new URLSearchParams(location.search);
        setOrders(result.data.orders);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
        setLoading(false)

        if (result.data.totalPages) {
          newQueryParams.set("totalPages", result.data.totalPages);
        }
        //navigate({ search: newQueryParams.toString() });
      } else {
        setOrders([])
        setLoading(false)
      }
    }
    catch (error) {
    }
  }

  const changeStatus = async (orderId, orderNumber) => {
    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/Order/updateOrderStatus?orderId=${orderId}&deliveryStatus=${selectedDeliveryStatus}`, {
        method: 'PUT',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        }
      })

      const result = await response.json()

      if (result.statusCode === 201) {
        toast.success(<span>Статусот на нарачката <span className='font-bold'>{orderNumber}</span> е успешно променет!</span>);
        setEditingOrderId(null);
        setOrders(orders.map(o =>
          o.id === orderId ? { ...o, deliveryStatus: selectedDeliveryStatus } : o
        ));

        setLoading(false)
      } else {
        toast.warning(`Статусот на нарачката не е успешно променет!`);
        setOrders([])
        setLoading(false)
      }
    }
    catch {

    }
  }

  const handlePageSizeChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('currentPage', '1');
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setPageSize(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handleSortByChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setSortBy(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handlePageChange = (page) => {
    const newQueryParams = new URLSearchParams(location.search);

    if (page) {
      newQueryParams.set('currentPage', page);
    } else {
      newQueryParams.delete('currentPage');
    }
    navigate({ search: newQueryParams.toString() });

    setCurrentPage(page)
  };

  const handleEdit = (orderId, currentDeliveryDescription) => {
    setEditingOrderId(orderId);
    setSelectedDeliveryStatus(currentDeliveryDescription);
  };

  const handleSave = (orderId, orderNumber) => {
    changeStatus(orderId, orderNumber)
    // Sačuvaj novu vrednost (ovo možeš povezati sa API-jem ili globalnim state-om)
  };


  const handleChange = (event) => {
    const selectedValue = parseInt(event.target.value)
    setSelectedDeliveryStatus(selectedValue);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
    }
    if(event.key === 'Escape'){
      clearInput();
    }
  };

  const handleSearchIconClick = () => {
    if (searchedOrder.length > 0 && searchedOrder.length < 4) {
      return;
    }
    fetchOrders(searchedOrder, sortBy, pageSize, currentPage);
  };

  const clearInput = () => {
    setSearchedOrder('');
    fetchOrders('', sortBy, pageSize, currentPage);
  };


  return (
    <div className="p-6">
      <div className='flex flex-col'>
        <div className='ml-auto'>
          <label htmlFor='pageSize'>Прикажи:</label>
          <select
            className="mb-4"
            name='pageSize'
            id='pageSize'
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className='ml-auto'>
          <select
            className="mb-4"
            name='sortBy'
            value={sortBy}
            onChange={handleSortByChange}
          >
            <option value="">Стандардно подредување</option>
            <option value="created_desc">Најновите први</option>
            <option value="created_asc">Најстарите први</option>
          </select>
        </div>
        <div className="flex items-center border border-gray-300 rounded-lg p-[1px] max-w-[180px] mr-1">
          <input
            type="text"
            className="flex-grow p-1 outline-none w-full"
            placeholder="Пребарувај нарачки"
            value={searchedOrder}
            onChange={(e) => setSearchedOrder(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {searchedOrder && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-5 w-5 text-gray-500 cursor-pointer"
              onClick={clearInput}
            >
              <path
                fillRule="evenodd"
                d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-5 w-5 text-gray-500 cursor-pointer"
            onClick={handleSearchIconClick}
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>


        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table table-zebra table-sm min-w-[600px] w-full text-[13px]">
          <thead>
            <tr className='text-[13px]'>
              <th className='w-[30px]'>Id</th>
              <th className='p-[5px]'>Број на нарачка</th>
              <th className='p-[5px]'>Име и презиме</th>
              <th className='p-[5px]'>Начин на плаќање</th>
              <th className='p-[5px]'>Вкупна цена</th>
              <th className='p-[5px]'>Достава</th>
              <th className='p-[5px] w-[200px]'>Статус на нарачка</th>
              <th className='p-[5px]'>Производи</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(order => (
              <tr key={order.id}>
                <td>{order.id}</td>
                <td className='font-semibold'>{order.orderNumber}</td>
                <td>{order.customer.firstName} {order.customer.lastName}</td>
                <td>{order.paymentDescription}</td>
                <td>{order.totalPrice} ден</td>
                <td>{order.deliveryPrice} ден</td>
                <td>
                  {editingOrderId === order.id ? (
                    <select value={selectedDeliveryStatus} onChange={handleChange}>
                      {deliveryStatus.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <span onClick={() => handleEdit(order.id, order.deliveryStatus)} data-tip="Промени го статусот"
                      className={`cursor-pointer tooltip border-2 ${order.deliveryStatus === 3 ? 'border-green-200 border-b-green-500' : 'border-orange-200 border-b-orange-500'}`}>
                      {deliveryStatus.find((status) => status.value === order.deliveryStatus)?.label} <FontAwesomeIcon icon={faPencil} />
                    </span>
                  )}
                  {editingOrderId === order.id && (
                    <div className='flex justify-center'>
                      <button
                        className="btn btn-sm btn-success block mt-[5px] mr-4 tooltip"
                        onClick={() => handleSave(order.id, order.orderNumber)}
                        data-tip="Зачувај промена"
                      >
                        <FontAwesomeIcon icon={faSave} />
                      </button>
                      <button
                        className="btn btn-sm btn-error block mt-[5px] tooltip"
                        onClick={() => setEditingOrderId(null)}
                        data-tip="Откажи"
                      >
                        <FontAwesomeIcon icon={faCircleXmark} />
                      </button>
                      {loading && (<span className="loading loading-spinner loading-xs"></span>)}
                    </div>
                  )}
                </td>
                <td className='max-w-[150px]'>
                  <ul>
                    {order.orderItems.map(orderItem => {
                      return (
                        <li key={orderItem.id}>
                          {orderItem.item.title} x <span className='font-bold'>{orderItem.quantity}</span>
                        </li>
                      );
                    })}
                  </ul>
                </td>
                <td>
                  <div className="tooltip" data-tip="Види детално">
                  <Link
                    to={`/wrongPage/order/${order.id}`}  // Ова е исправната рута на која сакаш да одиш
                    className="btn btn-sm btn-primary ml-2"  // Класите за стилување
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </Link>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length > 0 && (
          <>
            <div className='text-center'>Тековна страна: {currentPage}</div>
            <div className='text-center'>Вкупно производи: {totalItems}</div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            /></>
        )}
      </div>
    </div>
  )
}

export default Orders
